export enum AnimatedBoxesPages {
  SectionSummary = 1,
  UsersManagement = 2,
  Events = 3,
  SMSCredit = 4,
  Notices = 5
}
